import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';

import { TextEditorValue } from '@dreryk/react-text-editor';
import { FieldController } from '@dreryk/react-common';

import { subjectiveAssessmentTranslationKeys } from '../../../translations';
import { SubjectiveAssessmentTextEditor } from '../../form/examinations/SubjectiveAssessmentTextEditor';
import { StyledPrescriptionVisitDataModalField } from '../PrescriptionVisitDataModal.styled';

type SubjectiveAssessmentFieldProps = {
   readonly controller: FieldController<TextEditorValue | null>;
   readonly practitionerId: PractitionerId;
   readonly visitId: number;
};

export const SubjectiveAssessmentField = (props: SubjectiveAssessmentFieldProps): JSX.Element => {
   return (
      <StyledPrescriptionVisitDataModalField>
         <SubjectiveAssessmentTextEditor
            controller={props.controller}
            practitionerId={props.practitionerId}
            visitId={props.visitId}
            label={subjectiveAssessmentTranslationKeys.label}
         />
      </StyledPrescriptionVisitDataModalField>
   );
};
